import './contact.less';
import './static_page.less';
import classNames from 'classnames';

import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import ContactMap from './contact_map';
import {Link} from 'react-router';
import Header from '../header/header';
import Footer from '../footer/footer';

import DashBoardHeader from '../header_dashboard/dashboard_header';
import cookies from '../util/cookie';
import authActions from '../auth/auth_actions';

class Contact extends React.Component{
  constructor(props){
    super(props);
    this.logout = this.logout.bind(this);
  }

  logout() {
    this.props.authActions.logout().always(() => {
        cookies.delete('_sd');
        document.location.href = '/';
    });
  }

  render(){
    // const url ='mailto:?subject='+ "Join AWB" + '&body=Click on link to join AWB%0A%0A'+encodeURIComponent(state.inviteUrl)+'%0D%0A%0D%0A';
    const url = 'mailto:info@AirWayBill.com';
    const {state, props} = this;
    let user = {
      name: '',
      imageUrl: '',
      isVerified: ''
    };
    let isSessionValid = false;

    if('userData' in props.authState){
      isSessionValid  = props.authState.userData.sessionValid
    }

    if(isSessionValid && props.authState){
        user.name = props.authState.userData.name;
        user.imageUrl = props.authState.userData.profileImageUrl;
        user.isVerified = props.authState.userData.isVerified;
    }

    return(
      <div className="static-page contact-us-page">
        {!isSessionValid && <Header isFixedHeader={true} /> }
        {isSessionValid &&  <DashBoardHeader user = {user} logout={this.logout} /> }
        <div className = {classNames('static-header-wrap', {'no-margin-top' : isSessionValid})}>
          <h1 className = "static-header">Contact Us</h1>
        </div>
        <div className = "static-page-wrapper">
          <ContactMap />
          <h4 className ="static-sub-header">Social Links</h4>
          <div className = "social-links">
            <a href = "https://www.facebook.com/AirWayBill/" target="_blank">
              <i className = "icon-facebook2 social-link-img facebook"></i>
            </a>
            <a href = "https://twitter.com/awbapp" target="_blank">
              <i className = "icon-twitter2 social-link-img twitter"></i>
            </a>
            <a href = "https://www.linkedin.com/company/airwaybill-s.l." target="_blank">
              <i className = "icon-linkedin2 social-link-img linkedin"></i>
            </a>
            <a href = {url}>
              <i className = "icon-email social-link-img no-padding inbox"></i>
            </a>
          </div>
        </div>
        <Footer />
      </div>
    )
  }
}

//connect Login modal and signup modal with actions and state
const mapStateToProps = (state) => {
  return {
    authState : state.app.auth || {}
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    authActions : bindActionCreators(authActions, dispatch)
  }
}

Contact = connect(
  mapStateToProps,
  mapDispatchToProps
)(Contact)


export default Contact;



// WEBPACK FOOTER //
// app/static_pages/contact.jsx